import React, { Component } from 'react';
import { orderBy } from 'lodash';
import { PulseLoader } from 'react-spinners';
import { fetchSampleGroups, fetchSiteAttributes, fetchSequencingRuns } from '../api';
import NextSeqPacBioRunsQueuedTable from '../components/NextSeqPacBioRunsQueuedTable';
import RunsUpcomingTable from '../components/RunsUpcomingTable';
import RunsQueuedTable from '../components/RunsQueuedTable';
import SamplesReceivedTable from '../components/SamplesReceivedTable';
import { nSamplesInGroups, nSamplesInRuns, filterCurrentRuns } from '../utils';

const stylesHeaderText = {
  textAlign: 'center',
  fontWeight: '400',
  fontSize: 'x-large',
};

class App extends Component {
  state = {
    queues: {},
    samplesReceived: [],
    sampleProcessingRate: null,
    runs: [],
    loadingSequencingRuns: true,
    loadingSampleGroups: true,
    loadingProcessingRate: true,
    error: false,
  };

  handleError = () => {
    this.setState({
      error: true,
      loading: false
    });
  };

  componentDidMount() {
    fetchSequencingRuns()
      .then(runs => {
        this.setState({ runs, loadingSequencingRuns: false });
      })
      .catch(this.handleError);
    fetchSampleGroups()
      .then(samplesReceived => {
        this.setState({ samplesReceived, loadingSampleGroups: false });
      })
      .catch(this.handleError);
    fetchSiteAttributes()
      .then(attributes => {
        this.setState({
          sampleProcessingRate: attributes.sample_processing_rate,
          loadingProcessingRate: false
        });
      });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{textAlign: 'center', fontSize: '1.5em', marginTop: '20px' }}>
          There was a problem loading the queue. Please try again later.
        </div>
      );
    }

    const loading = this.state.loadingSampleGroups
      || this.state.loadingSequencingRuns
      || this.state.loadingProcessingRate;
    if (loading) {
      return (
        <div style={{textAlign: 'center'}}>
          <PulseLoader loading={loading} color={'#281835'} />
          <p style={{textAlign: 'center'}}>Loading queue...</p>
        </div>
      );
    }

    const { runs, samplesReceived, sampleProcessingRate } = this.state;
    const nTotalSamples = nSamplesInRuns(filterCurrentRuns(runs, false))
      + nSamplesInGroups(samplesReceived);
    const miseqRuns = runs.filter(run => run.queue === 'MiSeq');
    const nextseqRuns = runs.filter(run => run.queue === 'NextSeq');
    const pacBioRuns = runs.filter(run => run.queue === 'PacBio');
    return (
      <div>
        <h3 style={{ textAlign: 'center' }}>
          Sample processing rate:&nbsp;
          {sampleProcessingRate !== null ? `~${sampleProcessingRate} samples processed/month` : '-'}
        </h3>
        <div style={stylesHeaderText}>
          Current total number of samples/slots committed to queue: &nbsp;
          <span style={{ color: 'red' }}>{nTotalSamples}</span>
          <br />
          {/* TODO(karlrl): Use the last modified time of any resource for this? */}
          {/*Last update of queue: &nbsp; <span style={{ color: 'red' }}>Apr.5</span>*/}
        </div>
        <p></p>
        <table>
        <tbody>
          <tr>
            <td align="center">
              <RunsUpcomingTable
                platformName='MiSeq'
                runs={filterCurrentRuns(miseqRuns)} />
            </td>
            <td align="center">
              <RunsUpcomingTable
                platformName='NextSeq'
                runs={filterCurrentRuns(nextseqRuns)} />
            </td>
            <td align="center">
              <RunsUpcomingTable
                platformName='PacBio'
                runs={filterCurrentRuns(pacBioRuns)} />
            </td>
          </tr>
        </tbody>
        </table>
        <section>
          <p>
            <font size="3em">
              Legend:
              <span className="dotO">●</span> = in progress/pending;
              <span className="dotG">●</span> = completed;
              Extr. = extracted (either in advance by client, or by IMR);
              Libr. = library prepared; Seq. = sequenced;
              Anal. = analyzed (if requested).
            </font>
          </p>
          <p></p>
          <table>
            <tbody>
              <tr>
                <td align="center" style={{ width: '32%' }}>
                  <SamplesReceivedTable sampleGroups={samplesReceived.reverse()}/>
                </td>
                <td style={{ width: '2%' }}>&nbsp;</td>
                <td align="center" style={{ width: '32%' }}>
                  <RunsQueuedTable platformName='MiSeq' runs={miseqRuns}/>
                </td>
                <td style={{ width: '2%' }}>&nbsp;</td>
                <td align="center" style={{ width: '32%' }}>
                  {/* This is a (temporary) special queue table while PacBio is mixed with the NextSeq queue */}
                  <NextSeqPacBioRunsQueuedTable
                    platformName='NextSeq'
                    runs={orderBy([...nextseqRuns, ...pacBioRuns], ['planned_start'], ['desc'])}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </section>
      </div>
    );
  }
}

export default App;
